import { combineReducers } from 'redux'
import app from './app'
import search from './search'

export default combineReducers({ app, search })
